import { firebaseConfig } from '../../config/firebase';

let fbModules: any | null = null;
let fbDb: any | null = null;
let fbAuth: any | null = null;

export async function loadFirebase() {
    if (fbModules && fbDb && fbAuth) return { fbModules, fbDb, fbAuth };

    // dynamic import to avoid hard dependency during local dev
    const app = await import('firebase/app');
    const database = await import('firebase/database');
    const auth = await import('firebase/auth');

    const { initializeApp, getApps } = app as any;
    const { getDatabase } = database as any;
    const { getAuth } = auth as any;

    if (!getApps().length) {
        initializeApp(firebaseConfig);
    }

    fbModules = database;
    fbDb = getDatabase();
    fbAuth = getAuth();

    return { fbModules, fbDb, fbAuth };
}
